import React from 'react';

const DashboardStats = () => {
  const stats = [
    { title: 'Mascotas hoy', value: '24', change: '+3', color: 'bg-cyan-100 text-cyan-600' },
    { title: 'Paseos', value: '12', change: '+2', color: 'bg-purple-100 text-purple-600' },
    { title: 'Nuevos clientes', value: '5', change: '+1', color: 'bg-green-100 text-green-600' },
    { title: 'Ingresos', value: '$1,240,000 COP', change: '+$120,000', color: 'bg-orange-100 text-orange-600' }
  ];

  return (
    <div className="ml-64 p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat) => (
        <div key={stat.title} className="bg-white rounded-xl shadow-sm p-6">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm">{stat.title}</p>
              <p className="text-2xl font-bold mt-1">{stat.value}</p>
            </div>
            <span className={`text-xs px-2 py-1 rounded-full ${stat.color}`}>{stat.change}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;